module.exports = __webpack_public_path__ + "img/logo.e506a29c.png";